import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { ChatWidgetComponent } from '../../features/chatbot/chat-widget.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, ChatWidgetComponent],
  template: `
    <div class="shell">
      <app-sidebar />
      <main class="content">
        <router-outlet />
      </main>
    </div>
    <app-chat-widget />
  `,
  styles: [`
    @use '../../../styles/variables' as v;

    .shell {
      display: flex;
      height: 100vh;
      overflow: hidden;
      background: v.$background;
    }

    .content {
      flex: 1;
      overflow-y: auto;
      padding: 28px 32px;
      background: v.$background;
    }
  `],
})
export class MainLayoutComponent {}
